"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    assertArrayNonEmpty: function() {
        return assertArrayNonEmpty;
    },
    filterFalsey: function() {
        return filterFalsey;
    },
    filterUndefined: function() {
        return filterUndefined;
    },
    getFirstElement: function() {
        return getFirstElement;
    },
    mapField: function() {
        return mapField;
    },
    mustGetFirstElement: function() {
        return mustGetFirstElement;
    },
    mustGetLastElement: function() {
        return mustGetLastElement;
    },
    mustGetOnlyElement: function() {
        return mustGetOnlyElement;
    },
    uniqueCount: function() {
        return uniqueCount;
    }
});
const _validation = require("./validation");
function filterFalsey(input) {
    return (input != null ? input : []).filter((x)=>!!x);
}
function filterUndefined(input) {
    return (input != null ? input : []).filter((x)=>x !== undefined);
}
function getFirstElement(arr) {
    if (!(arr == null ? void 0 : arr.length)) return undefined;
    return arr[0];
}
function assertArrayNonEmpty(arr, errorMessage) {
    if (!arr.length || arr.length < 1) {
        (0, _validation.throwValidationError)(errorMessage != null ? errorMessage : `The array was expected to have at least one element, but it had length=${arr.length}`);
    }
}
function mustGetFirstElement(arr, errorMessage) {
    assertArrayNonEmpty(arr, errorMessage);
    return arr[0];
}
function mustGetLastElement(arr, errorMessage) {
    assertArrayNonEmpty(arr, errorMessage);
    return arr[arr.length - 1];
}
function mustGetOnlyElement(arr, errorMessage) {
    if (!arr.length || arr.length !== 1) {
        (0, _validation.throwValidationError)(errorMessage != null ? errorMessage : `The array was expected to have exactly one element, but it had length=${arr.length}`);
    }
    return arr[0];
}
function mapField(arr, property) {
    return arr.map((element)=>element[property]);
}
function uniqueCount(xs) {
    return new Set(xs).size;
}

//# sourceMappingURL=array.js.map